import useValidation from "../../hooks/useValidation";
import { useEffect } from "react";
import { CompanyNameType } from "../../static/types/commonTypes/companyNameType";
import companyNameValidationSchema from "../../utils/validation/companyNameValidationScehma";
import useAppContext from "../../hooks/useAppContext";
import { AppContextType } from "../../context/AppContext";

type companyNameProps = {
  checked: boolean;
  companyName: CompanyNameType;
  changeCompanyName: (companyName: Partial<CompanyNameType>) => void;
  onValidationChange: (isValid: boolean) => void;
  showClientReference?: boolean;
  showRequiredIndicator?: boolean;
  draftFieldName?: string
};

export default function CompanyName({
  checked,
  companyName,
  changeCompanyName,
  onValidationChange,
  draftFieldName = 'companyName',
  showClientReference = true,
  showRequiredIndicator = true,
}: companyNameProps) {

  
  const {
      draftFormData, setDraftFormData
  } = useAppContext() as AppContextType
  
  const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
  const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

  const { errors, isValid } = useValidation(
    companyName,
    companyNameValidationSchema
  );

  useEffect(() => {
    onValidationChange(isValid);

    const draft = parseDraft()
    const tempDraft = { ...draft, [ draftFieldName ] : companyName }
    setDraftFormData( stringifyDraft( tempDraft ))
  }, [isValid, onValidationChange]);

  return (
    <div className="mb-3 row">
      <label htmlFor="companyName" className="col-sm-2 col-form-label">
        Dénomination
        { showRequiredIndicator && <span className="text-danger"> *</span>}
      </label>

      <div className="col-sm-10 mb-3">
        <input
          className={`form-control ${
            (showRequiredIndicator && checked && errors.companyName) ? "is-invalid" : ""
          }`}
          id="companyName"
          onChange={(event) =>
            changeCompanyName({ companyName: event.target.value })
          }
          value={companyName.companyName}
        />

        {(showRequiredIndicator && checked && errors.companyName) && (
          <div className="invalid-feedback">{errors.companyName}</div>
        )}
      </div>

      {showClientReference && (
        <>
          <label htmlFor="clientReference" className="col-sm-2 col-form-label">
            Référence client
          </label>

          <div className="col-sm-10 mb-3">
            <input
              className={`form-control ${
                checked && errors.clientReference ? "is-invalid" : ""
              }`}
              type="text"
              id="clientReference"
              value={companyName.clientReference}
              onChange={(event) =>
                changeCompanyName({ clientReference: event.target.value })
              }
            />

            {checked && errors.clientReference && (
              <div className="invalid-feedback">{errors.clientReference}</div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
